module.exports = __webpack_public_path__ + "img/rsvp.b06621e1.png";